import { match } from 'ts-pattern';
import { LynxSedonaGrill as LynxSedonaGrillV10 } from '../__generated/model/versions/v10.js';
export const migrateToV11 = (state)=>{
    return state.map((entity)=>{
        return match(entity).returnType().when((e)=>LynxSedonaGrillV10.isId(e.id), ({ powderCoating, ...entity })=>({
                ...entity
            })).otherwise((other)=>other);
    });
};

//# sourceMappingURL=v11.js.map